import { useEffect } from "react";
import { useCustomerValidate } from "./hooks/useCustomerValidate";
import { Dialog, DialogActions, DialogContent, DialogTitle, FlexGrid, Typography, Button } from "@albo-ui/core";
import { Box, MenuItem, TextField, Select, FormControl, InputLabel, IconButton } from "@mui/material";
import { AttachFile } from "@mui/icons-material";

export const CustomerValidate = ({ changeAlert, changeLoader, afbClevelList, lead, flag, open, onClose}: any) => {
    const { form, zPos, names, title, error, disabled, listClevelReason, attachDisabled, onStoreData, onDeleteFile, onFileLoad, onSelectReason, onChangeComment, onHandelUpdate } = useCustomerValidate(changeAlert, changeLoader, onClose, afbClevelList)

    useEffect(() => {
        open && onStoreData(lead, flag);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    const addFile = () => {
        document.getElementById("file").click();
    };
    
    return (
        <Dialog onClose={onClose} open={open} style={{ display: zPos !== 45 ? "none" : null, minWidth: 600, maxHeight: 500 }}>
            <DialogTitle>
                <Box display={"flex"} alignItems={"center"} mb={2}>
                    <Typography variant='h2' style={{fontSize: '1.2rem'}}>{title}</Typography>
                </Box>
			</DialogTitle>

            {form && <DialogContent>
                <FlexGrid item >
                <FormControl variant="outlined" fullWidth >
                    <InputLabel size="small">{"Motivo"}</InputLabel>
                    <Select value={form["result"]["reason"] || ""} onChange={onSelectReason.bind(this)} color="secondary" MenuProps={{style: {zIndex: 35001}}} sx={{mb: 2}} inputProps={{ shrink: "true" }} fullWidth variant="outlined" size="small">
                        <MenuItem value="" disabled>{"Selecione un motivo"}</MenuItem>
                        { listClevelReason?.map((item, index) => (
                            <MenuItem key={index} value={item.key}>{item.key}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
                </FlexGrid>

                <FlexGrid item >
                    <TextField value={form["result"]["comment"] || ""} multiline minRows={1} maxRows={2} onChange={onChangeComment.bind(this)} label="Comentarios" size="small" fullWidth />
                </FlexGrid>

                <FlexGrid item >
                    <TextField id="file" type="file" onChange={onFileLoad.bind(this)} size="small" fullWidth style={{ display: "none" }}/>
                </FlexGrid>

                {form["result"]["files"].length > 0 && names.length > 0 && 
                    names.map((item, index) => {
                    return (
                        <FlexGrid key={index} container spacing={2} style={{marginLeft: "0", marginBottom: "11px", marginBlock: 20 }} >							
                            <FlexGrid item alignItems="center" >
                                <TextField value={item}
                                    label={`Evidencia ${index + 1}`} key={`file-${index}`} disabled size="small" fullWidth />
                                </FlexGrid>
                                <FlexGrid item >
                                    <Button onClick={onDeleteFile.bind(this, index)} size="small" style={{width: 80}}>Eliminar</Button>
                                </FlexGrid>
                        </FlexGrid>	
                    );
                })}		
                
                {error && <Typography variant="small" color="required">{error}</Typography>}
                
                <FlexGrid fullWidth fullHeight style={{marginTop: 20}}>
                    <IconButton onClick={addFile.bind(this)} disabled={attachDisabled} sx={{padding: "0 !important"}}>
                        <AttachFile  sx={{padding: "7px", borderRadius: 2, boxSizing: "content-box", color: "white", backgroundColor: attachDisabled ? "lightgray" : "#8bc179" }} />
                    </IconButton>
                </FlexGrid>
            </DialogContent>}

            <DialogActions>
                <FlexGrid container fullHeight fullWidth justify="space-between" alignItems="flex-end" style={{ marginTop: 10 }}>
                    <FlexGrid item>
                        <Button onClick={onClose} buttonType="secondary" size="normal">Cancelar</Button>
                    </FlexGrid>
                    <FlexGrid item>
                        <Button disabled={disabled} onClick={onHandelUpdate.bind(this)} size="normal" >Guardar</Button>
                    </FlexGrid>
                </FlexGrid>
            </DialogActions>
        </Dialog>
    );
};
